// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__RyORx","background":"Hero_background__h76ao","footballer":"Hero_footballer__yDDzI","text":"Hero_text__h5r+z"};